import { ImgHTMLAttributes } from 'react';

interface OptimizedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  priority?: boolean; // true for above-the-fold images (Hero)
  className?: string;
}

/**
 * Optimized Image Component
 * - Uses native lazy loading for better performance
 * - Priority images load eagerly (Hero images)
 * - Prepares for WebP format support
 * - High fetchpriority for critical images
 */
const OptimizedImage = ({ 
  src, 
  alt, 
  priority = false, 
  className = '',
  ...props 
}: OptimizedImageProps) => {
  return (
    <img
      src={src}
      alt={alt}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      decoding={priority ? 'sync' : 'async'}
      className={className}
      {...props}
    />
  );
};

export default OptimizedImage;
